export default {
	title: "Registrar Templo",
	subtitle: "Cree su cuenta y registre su templo",
	brandingTitle: "Gestione su Templo",
	brandingDesc: "Sistema completo para la gestión de templos de Umbanda",
	confirmPassword: "Confirmar contraseña",
	templeName: "Nombre del Templo",
	templeNameHint: "Inicial mayúscula en cada palabra (o todo en mayúsculas)",
	acronym: "Sigla",
	acronymHint: "2-10 caracteres en mayúsculas, se usará en la URL del templo",
	submit: "Registrar Templo",
	success: "¡Registro realizado! Verifique su correo electrónico para activar la cuenta.",
	error: "Error al registrar. Inténtelo de nuevo.",
	subscribingNotice: "Estás iniciando la suscripción a un plan. Tras crear la cuenta y confirmar el correo, revisarás el plan y finalizarás el pago.",
};
